// routes/messages/index.tsx
// -----------------------------------------------------------------------------
// Chat has been disabled. Redirect any bookmarked/cached URLs to home.
// -----------------------------------------------------------------------------

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/messages/")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
